import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useEditorActions } from '../../hooks/useEditorActions';
import EditorIncludeObjectsWithNoValueSetInput from './EditorIncludeObjectsWithNoValueSetInput';
import EditorConditionBase from './EditorConditionBase';
import { useStrategy } from '../../hooks/useStrategy';
import getConditionId from '../../utils/getConditionId';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorCondition = props => {
  const {
    condition,
    filterFamily,
    conditionPath,
    dataSeleniumInfo,
    inputUse,
    isNested
  } = props;
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    isIncludeObjectsWithNoValueSetCheckboxEnabled
  } = useStrategy();
  return /*#__PURE__*/_jsx(EditorConditionBase, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: filterFamily,
    onConditionDelete: () => onConditionDelete(conditionPath),
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onFieldConditionValueChange,
    inputUse: inputUse,
    isNested: isNested,
    children: isIncludeObjectsWithNoValueSetCheckboxEnabled && /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoValueSetInput, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      onChange: onFieldConditionValueChange,
      spaceStyleProps: {
        marginBlockStart: '200'
      }
    })
  }, getConditionId(conditionPath));
};
export default EditorCondition;